import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1 pb-100">
      <div className="container">
        <div className="info">
          <h1 className="js-title"> contact </h1>
          <div className="text fsz-18 color-666">
            Get in Touch Contact Details Whether it’s a CSR initiative or a design project, our team brings creativity, precision, and commitment to every detail.{' '}
            <br /> Connect with REDANT STUDIO and take the first step toward meaningful transformation.{' '}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
